import React, { Component } from 'react';
import { connect } from 'react-redux';
import Util from '../../util.js';
import { getQueryTransitRecords } from '../../action/investmentAction';

import { compareTime, getDateS} from "../../getPay";
/*在途资金交易明细*/
import { hashHistory } from 'react-router';
import NavigatorMain from '../NavigatorMain';

class TransitRecords extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  componentWillMount() {
    let { dispatch } = this.props;
    dispatch(getQueryTransitRecords({},()=>{},this)); 
    document.title = "在途资金交易明细";
  }

  goBack(){
    // hashHistory.push({
    //     pathname:'/',
    // })
    hashHistory.go(-1)
  }

  goTransactionDetail(item){
    let data = {
      businessType:item.businessType,
      tradeRequestId:item.tradeRequestId
    }
    hashHistory.push({
        pathname:'/TransactionDetail',
        state:{
          data
        }
    })
  }
            
  render() {
    //let data = this.props.QueryTransitRecords ? this.props.QueryTransitRecords : [];
  
    let data;
    if(this.props.QueryTransitRecords){
      data = this.props.QueryTransitRecords;
      data.sort(compare('businessTime'))
    }else{
      data = [];
    }

    return (
        <div className="container">
          <NavigatorMain>
          <div className="header black">
            <div style={{ WebkitFlex:1, flex:1 }}><span className="headerLeftBtn" onClick={ ()=> this.goBack() }></span></div>
            <div style={{ WebkitFlex:2, flex:2, textAlign:'center',fontSize:"0.3rem" }}>在途资金交易明细</div>
            <div style={{ WebkitFlex:1, flex:1, textAlign:'right',fontSize:"0.28rem", paddingRight:'13px'}}></div>    
          </div>
          </NavigatorMain>
          <div className='content'>
          {
            data.map((item,i)=>{
              return(
                <div className="superListJ" key ={i} onClick={ ()=> this.goTransactionDetail(item) }>
                  <div style={{ borderBottom:'1px solid #f2f4f7'}}><span style={{ color:'#fa063a'}}>{ item.businessTypeName }</span><span></span></div>
                  <div>
                    <span>{ item.superFundName }</span><span>{ Util.fomatFloat(item.transitAmount) + "元" }</span>
                  </div>
                  <div>
                    <span>{ item.businessStateName }</span><span>{  Util.formatStr(item.businessTime) }</span>
                  </div>
                </div>
              )
            })
          }
          <div style={{marginTop:20,marginBottom:30,paddingLeft:13,paddingRight:13}}>
			        <div style={{height:30,fontSize:12}}>温馨提示 :</div>
		            <div  style={{color:'rgba(130,138,138,1)',fontSize:12,lineHeight:"22px"}}>1、当投顾组合有申购在途交易时，申购的底层货币份额将实时确认并显示在组合资产中，其他成分基金需申购确认后，方可显示在组合资产中。</div>
		            <div  style={{color:'rgba(130,138,138,1)',fontSize:12,lineHeight:"22px"}}>2、当投顾组合有部分赎回在途交易时，组合底层货币份额将全部冻结，不在剩余组合资产中显示。待组合赎回交易确认后，剩余底层货币份额方可显示在组合资产中。</div>
		            <div  style={{color:'rgba(130,138,138,1)',fontSize:12,lineHeight:"22px"}}>3、当投顾组合有调仓在途交易时，组合资产将暂停展示，待调仓交易确认后，方可查看组合资产。</div>
			  	</div>
          {/*
          <div className="superListJ superOperation">
            <div style={{ borderBottom:'1px solid #f2f4f7'}}><span style={{ color:'#fa063a'}}>投资申请</span><span></span></div>
            <div><span>常青藤大学组合</span><span>1000.00元</span></div>
            <div><span>已受理</span><span>2017-07-12 17:13:30</span></div>
          </div>

          <div className="superListJ superOperation">
            <div style={{ borderBottom:'1px solid #f2f4f7'}}><span style={{ color:'#fa063a'}}>华夏智投银行卡申购</span><span></span></div>
            <div><span>常青藤大学组合</span><span>1000.00元</span></div>
            <div><span>已受理</span><span>2017-07-12 17:13:30</span></div>
          </div>
          */}
          </div>
        </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    QueryTransitRecords:state.QueryTransitRecords
  }
}

export default connect(mapStateToProps)(TransitRecords);

function compare(property){
    return function(a,b){
        var allStartDate = getDateS(a[property]);   
        var allEndDate = getDateS(b[property]);
        var value1 = allStartDate.getTime()
        var value2 = allEndDate.getTime()
        return value2 - value1;
    }
}



// WEBPACK FOOTER //
// ./src/components/fundDetail/TransitRecords.js